import { createSelector, defaultMemoize as memoize } from 'reselect';
import pick from 'lodash/fp/pick';
import { SORT_BY } from 'lib/enums/search';
import { PAYMENT_METHODS } from 'lib/enums/payment';
import { numberFromString } from 'lib/number';
import { dateFromString } from 'lib/date';
import { arrayFromDelimitedString } from 'lib/array';

const DEFAULT_SORT_BY = SORT_BY.PROMOTION.code;
const DEFAULT_PAYMENT_METHOD = PAYMENT_METHODS.CASH;

const memoizedCheckInDateFromString = memoize(dateFromString);
const memoizedCheckOutDateFromString = memoize(dateFromString);
const memoizedArrayFromDelimitedString = memoize(arrayFromDelimitedString);

const paymentMethod = (payWith) => (payWith ? String(payWith).toLowerCase() : DEFAULT_PAYMENT_METHOD);
const defaultedSearchType = (searchType) => (['list', 'map'].includes(searchType) ? searchType : 'list');

const pickSearchUntransformed = pick([
  'location',
  'minStarRating',
  'minTripadvisorRating',
  'featuredPropertyId',
  'featuredOfferId',
  'utm_source',
  'utm_medium',
  'utm_content',
  'utm_campaign',
  'utm_term',
  'trv_reference',
  'gclid',
  'swLat',
  'swLng',
  'neLat',
  'neLng',
]);

export const createSearchQuerySelector = (rawQuerySelector) =>
  createSelector(
    rawQuerySelector,
    ({
      checkIn,
      checkOut,
      adults,
      children,
      infants,
      sortBy,
      propertyTypes,
      payWith,
      minPrice,
      maxPrice,
      searchType,
      facilities,
      freeCancellation,
      depositPay,
      classicRewards,
      page,
      subRegions,
      ...rest
    }) => ({
      ...pickSearchUntransformed(rest),
      checkIn: memoizedCheckInDateFromString(checkIn),
      checkOut: memoizedCheckOutDateFromString(checkOut),
      adults: numberFromString(adults),
      children: numberFromString(children),
      infants: numberFromString(infants),
      sortBy: sortBy || DEFAULT_SORT_BY,
      propertyTypes: memoizedArrayFromDelimitedString(propertyTypes),
      payWith: paymentMethod(payWith),
      minPrice: numberFromString(minPrice),
      maxPrice: numberFromString(maxPrice),
      searchType: defaultedSearchType(searchType),
      facilities: memoizedArrayFromDelimitedString(facilities),
      freeCancellation: freeCancellation === 'true' || undefined,
      depositPay: depositPay === 'true' || undefined,
      classicRewards: classicRewards === 'true' || undefined,
      page: numberFromString(page),
      subRegions: memoizedArrayFromDelimitedString(subRegions),
    }),
  );
